import { Button } from '@ps/sports-ui-component-library';
import type { IspSportsAlias } from '@ps/web-core-store';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import Link from '@swf/components/Link/Link';
import Translation from '@swf/components/Translation/Translation';
import type { RootState } from '@swf/core/store';
import { select } from '@swf/core/store';
import { Message } from '@swf/sports/components';
import { defaultToMatchesTab } from '@swf/sports/hooks/useUrlMenuItems';
import { configuredLandingPageEventTypeIds } from '@swf/sports/pages/config';

import {
  TXTWCL_Return_To_N0,
  TXTWCL_This_event_has_now_finishedX
} from './NoEventsMessage.messages.json';
import styles from './NoEventsMessage.scss';

const NoEventsMessage: React.FC = () => {
  const { eventTypeSlug, eventTypeId } = useSelector(select.sports.getUrlParams);
  const isEventTypeLandingPage = useSelector((state: RootState) =>
    select.sports.isEventTypeLandingPage(state, { configuredLandingPageEventTypeIds })
  );

  let alias: IspSportsAlias = defaultToMatchesTab.includes(Number(eventTypeId))
    ? 'sportsMatchFiltering'
    : 'sportsSport';
  if (isEventTypeLandingPage) alias = 'sportsLanding';

  return (
    <Message message={<Translation {...TXTWCL_This_event_has_now_finishedX} />}>
      <Button
        as={Link}
        alias={alias}
        values={{
          eventTypeId,
          eventTypeSlug
        }}
        className={classNames(styles.titleCase)}
      >
        <Translation values={{ 0: eventTypeSlug }} {...TXTWCL_Return_To_N0} />
      </Button>
    </Message>
  );
};

export default NoEventsMessage;
